import '../css/goldenhairclip.css';

import GoldenHairClipImage from '../images/campain/negativ-golden-hair-clip.webp';
import useDictionary from '../hooks/useDictionary';

import { useParams } from "react-router-dom";

export default function GoldenHairClip() {

    const dictionary = useDictionary();
    const params = useParams();

    return (
        <section className="golden-hair-clip" aria-labelledby="golden-hair-clip-title">
            <a
                className="golden-hair-clip-link"
                href={`/${params.lang}/golden-hairclip`}
                aria-label="Zobacz ofertę złotej spinki Negativ"
            >
                <div className="golden-hair-clip-copy">
                    <span className="golden-hair-clip-eyebrow">{dictionary.HAIRPIN_HEADER}</span>
                    <h2 id="golden-hair-clip-title">{dictionary.HARIPIN_TITLE_1}<br />{dictionary.HARIPIN_TITLE_2}</h2>
                    <span className="golden-hair-clip-cta">{dictionary.DISCOVER_OFFER_BTN} <span aria-hidden="true">↗</span></span>
                </div>
                <div className="golden-hair-clip-image-wrap">
                    <img
                        src={GoldenHairClipImage}
                        alt="Złota spinka do włosów Negativ"
                        className="golden-hair-clip-image"
                    />
                </div>
            </a>
        </section>
    );
}
